import { render, staticRenderFns } from "./syncTicketAccessModal.vue?vue&type=template&id=6d2f153e&scoped=true"
import script from "./syncTicketAccessModal.vue?vue&type=script&lang=js"
export * from "./syncTicketAccessModal.vue?vue&type=script&lang=js"
import style0 from "./syncTicketAccessModal.vue?vue&type=style&index=0&id=6d2f153e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2f153e",
  null
  
)

export default component.exports